import request from '@/utils/request'

const tradeProjectMaterialApi = {
  trade_project_material_list: '/trade/project_material/',
  trade_project_material_create: '/trade/project_material/',
  trade_project_material_update: '/trade/project_material/',
  trade_project_material_delete: '/trade/project_material/',
  trade_project_material_archived: '/trade/project_material_archived/'
}

/**
 * 列表
 */
export function project_material_list (parameter) {
  return request({
    url: tradeProjectMaterialApi.trade_project_material_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function project_material_create (parameter) {
  return request({
    url: tradeProjectMaterialApi.trade_project_material_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function project_material_update (parameter, project_material_id) {
  return request({
    url: tradeProjectMaterialApi.trade_project_material_update + project_material_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function project_material_delete (project_material_id) {
  return request({
    url: tradeProjectMaterialApi.trade_project_material_delete + project_material_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function project_material_archived (parameter) {
  return request({
    url: tradeProjectMaterialApi.trade_project_material_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
